import React, { useEffect, useState } from "react";
import DateTimeUtils from "../../services/DateTimeUtils";
import ApiService from "../../services/ApiService";

const CardOrder = ({ basketData }) => {
    const [courseRows, setCourseRows] = useState([]);
    const [orderData, setOrderData] = useState();

    useEffect(() => {
        const fetchCourseData = async () => {
            const courseList = [];
            let couponData;

            const promises = basketData.bookCourses.map(async (bookCourse) => {
                const courseData = await ApiService.getCourseById(bookCourse.courseId);
                const participantData = await ApiService.getParticipantById(bookCourse.participantId);
                const levelData = await ApiService.getLevelById(courseData.levelCourseId);
                couponData = basketData.couponId !== null ? await ApiService.getCouponById(basketData.couponId) : {discount: 0, cost: 0, }

                const row = (
                    <tr className="border-end border-start" key={courseData.id}>
                        <td className="border-end">
                            {courseData.title},<br />
                            {"Livello: " + levelData.level}<br />
                            {"Durata corso: " + courseData.noOfLessons + " lezioni"}<br />
                            {"Inizio corso: " + DateTimeUtils.formatCourseStart(courseData.start)}
                        </td>
                        <td className="border-end">
                            {participantData.firstName} {participantData.lastName}
                            <br />
                            {DateTimeUtils.getParticipantDob(participantData)}
                            <br />
                            {participantData.currentLevel}
                        </td>
                        <td>
                            <div className="text-end">{parseFloat(bookCourse.price).toFixed(2)}</div>
                        </td>
                    </tr>
                );

                courseList.push(row);
            });

            await Promise.all(promises);

            setCourseRows(courseList);
            setOrderData({
                discount: basketData.discountApplied ? "10%": "-",
                total: basketData.total,
                coupon: couponData.discount!== 0 || couponData.cost !== 0 ? (couponData.discount === 0? `${couponData.cost} CHF` : `${couponData.discount}%`) : "-"
            })
        };

        fetchCourseData();
    }, [basketData]);

    return (
        <table className="table mb-3">
            <thead className="border-end border-start border-top">
            <tr>
                <th scope="col">Corso</th>
                <th scope="col">Partecipante</th>
                <th scope="col" className="text-end">
                    Prezzo
                </th>
            </tr>
            </thead>
            <tbody>
            {courseRows.length === 0 ? (
                <tr>
                    <td colSpan={3}>Loading...</td>
                </tr>
            ) : (
                courseRows.map((courseRow, index) => (
                    <React.Fragment key={index}>{courseRow}</React.Fragment>
                ))
            )}
            <tr className="fw-bold border-end border-start">
                <td colSpan={2}>Sconti applicati</td>
                <td className="text-end">{orderData && orderData.discount}</td>
            </tr>
            <tr className="fw-bold border-end border-start">
                <td className="align-middle" colSpan={2}>
                    Buoni
                </td>
                <td className="text-end align-middle">{orderData && orderData.coupon}</td>
            </tr>
            <tr className="fw-bold border-end border-start">
                <td colSpan={2}>Totale</td>
                <td className="text-end">{orderData && parseFloat(orderData.total).toFixed(2) + " CHF"}</td>
            </tr>
            </tbody>
        </table>
    );

};

export default CardOrder;
